import { HealthDbServiceProvider, HealthServiceProvider, UserServiceProvider } from '#infra/service-providers';
import { InnovationServiceProvider } from '#infra/service-providers/innovation/innovation.service.provider';
import App from '#webui/App.vue';
import router from '#webui/router';
import { C4ToastNoticePlugin, Uuid } from '@c4-links/vue3-links-components';
import { createGtm } from '@gtm-support/vue-gtm';
import i18nextVue from 'i18next-vue';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import VueFeather from 'vue-feather';
import { config } from './config/env';
import { setupI18n } from './i18n/i18n';
import { visibleDirective } from './utils/visible.directive';

import '#assets/index.css';
import '@c4-links/vue3-links-components/style.css';

const i18n = await setupI18n();
const app = createApp(App);
const pinia = createPinia();

app.use(i18nextVue, { i18next: i18n });
app.provide('healthServiceProvider', new HealthServiceProvider());
app.provide('healthDbServiceProvider', new HealthDbServiceProvider());
app.provide('userServiceProvider', new UserServiceProvider());
app.provide('innovationServiceProvider', new InnovationServiceProvider());
app.use(C4ToastNoticePlugin, {});
app.use(Uuid);
app.use(router);
app.use(pinia);
app.use(
  createGtm({
    id: config.tracking.gtmId,
    enabled: config.tracking.enabled,
    debug: config.appEnv === 'local',
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    nonce: '2726c7f26c', // Will add `nonce` to the script tag
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router // Pass the router instance to automatically sync with router (optional)
  })
);

app.component(VueFeather.name ?? 'vue-feather', VueFeather);

app.directive('visible', visibleDirective);

app.mount('#app');
